<script>
import Menu from "./Menu";
import MenuMobile from "./MenuMobile";
import SubMenu from "./SubMenu";

export default {
  components: {
    Menu,
    MenuMobile,
    SubMenu
  }
};
</script>

<template>
    <div class="navbar">
        <Menu/>
        <MenuMobile/>
        <SubMenu/>
    </div>
</template>

<style scoped>
.navbar {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/Index.vue